import { useTranslation } from 'react-i18next';
import { wsManager } from '@api/websocket';
import { useStatusQuery } from '@http';
import { useAppStore } from '@stores';
import { useEffect } from 'react';

export function Loader() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Loader' });
  const { data } = useStatusQuery();
  const { isConnecting, isLoadingImages, isFetching, refetch } = useAppStore();

  useEffect(() => {
    if (!data) return;

    (async () => {
      localStorage.setItem('authToken', data.jwt);
      await refetch();

      if (data.newPlayer) {
        useAppStore.setState({ isConnecting: false, id: data.id });
      } else {
        useAppStore.setState({ isConnecting: false, id: data.id });
      }

      wsManager.connect(data.jwt);
    })();
  }, [data]);

  if (isFetching) return (
    <div className="fixed inset-0 bg-black/90 flex items-center justify-center z-100000">
      <span className="loader" />
    </div>
  );

  if (!isConnecting && !isLoadingImages) return null;

  return (
    <div className="fixed inset-0 bg-black flex flex-col items-center justify-center z-100001">
      <span className="main-loader" />
      <p className="mt-2 text-xs">
        {t(isConnecting ? 'connecting' : 'loadingAssets')}
      </p>
    </div>
  );
}